"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var user_1 = require("../../shared/model/user");
var Subject_1 = require("rxjs/Subject");
require("rxjs/add/operator/map");
require("rxjs/add/operator/catch");
var login_http_error_1 = require("../http-error/login-http-error");
var authentication_service_1 = require("../../shared/service/authentication.service");
var http_service_1 = require("../../shared/service/http.service");
var AUTH_ENDPOINT = '/auth';
var LoginService = /** @class */ (function () {
    function LoginService(_http, authenticationService) {
        this._http = _http;
        this.authenticationService = authenticationService;
        this.LOGIN = '/login';
        this.loginSubject = new Subject_1.Subject();
        this.login$ = this.loginSubject.asObservable();
        this.errorSubject = new Subject_1.Subject();
        this.error$ = this.errorSubject.asObservable();
    }
    LoginService.prototype.login = function (user) {
        var _this = this;
        this._http.post(AUTH_ENDPOINT + this.LOGIN, user, user_1.User, login_http_error_1.LoginHttpError)
            .subscribe(function (loggedUser) {
            _this.authenticationService.setUserOnLocalStorage(loggedUser);
            _this.loginSubject.next(loggedUser);
        }, function (error) { return _this.errorSubject.next(error); });
    };
    LoginService.ctorParameters = function () { return [{ type: http_service_1.HttpService }, { type: authentication_service_1.AuthenticationService }]; };
    return LoginService;
}());
exports.LoginService = LoginService;
//# sourceMappingURL=login.service.js.map


// WEBPACK FOOTER //
// login.service.js